const doc = [({"en":({"js":({"reimbursements":({"create_card":({"extended_form":({"save_and_request_approval_button":({"save_and_request_approval":"Request approval"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;